import SimpleTodos from './WikipediaSearch'
import './App.css'

const App = () => <SimpleTodos />

export default App
